import React, { FormEvent, useContext, useEffect, useRef } from "react";
// Importing the CSS File for the filter form
import styled from "styled-components";
import { AppContext } from "./AppContext";

const Checkbox = styled.input`
  & {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &::placeholder {
    font-family: "Avenir Next", Arial, sans-serif !important;
  }
  &::-moz-placeholder {
    font-family: "Avenir Next", Arial, sans-serif !important;
  }
`;

export const Input = (props: {
  handleClick: (e: any) => void;
  value: string;
  checked?: boolean;
  className?: string;
}) => {
  const InputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const { productFiltersGlobal } = useContext(AppContext);

  useEffect(() => {
    const parentElement = InputRef.current.parentElement;

    if (props.checked) {
      InputRef.current.setAttribute("checked", "true");

      // Setting the purple color
      const purpleColor = "#522398";
      // RGB version of the purple color
      const rgbPurpleColor = "rgb(82, 35, 152)";
      // CSS Style for BOLD Font Weight
      const boldFontWeight = 700;
      // CSS Style for normal font weight
      const normalFontWeight = "normal";

      const parentElementStyles = parentElement?.style;
      // Call function HandleCheck with the current object passed in
      if (parentElementStyles)
        if (parentElementStyles.color == rgbPurpleColor) {
          // Make the color go back to black
          parentElementStyles.color = "black";
          // Make the font weight return back to normal
          parentElementStyles.fontWeight = normalFontWeight;
        } else {
          // Else, make the element color purple
          parentElementStyles.color = purpleColor;
          // And, make the font weight bold
          parentElementStyles.fontWeight = boldFontWeight.toString();
        }
    }
  }, []);

  return (
    <Checkbox
      onClick={(e: FormEvent) => props.handleClick(e)}
      value={props.value}
      type="checkbox"
      ref={InputRef}
      checked={props.checked}
    />
  );
};

export default Input;
